<div class="card">
    <div class="flex flex-col items-center w-full" *ngIf="ready">
        <div class="w-full">
            <app-dynamic-form #myForm [options]="form2Opts" [fields]="regConfig2" (resetData)="initializeForm()" (submit)="submit($event)">
            </app-dynamic-form>
        </div>
        <app-edit-history [data]="editHistoryData"></app-edit-history>
    </div>
</div>